import { Link } from "react-router-dom";

export const LegalLayout = ({ title, updated, children, testId }) => (
  <div className="App bg-brand-dark min-h-screen" data-testid={testId}>
    <nav className="border-b border-brand-gold/10">
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <Link to="/" className="font-serif text-lg text-brand-mist hover:text-brand-gold transition-colors" data-testid="legal-nav-home">
          Brandi Jo Newman
        </Link>
        <Link to="/" className="font-sans text-sm text-brand-mist/60 hover:text-brand-gold transition-colors">
          ← Back to site
        </Link>
      </div>
    </nav>
    <main className="max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24">
      <h1 className="font-serif text-4xl md:text-5xl text-brand-mist mb-3">{title}</h1>
      <p className="font-sans text-sm text-brand-mist/50 mb-12">Last updated: {updated}</p>
      <div className="space-y-8">{children}</div>
    </main>
    <footer className="py-10 border-t border-brand-gold/10">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <p className="font-sans text-xs text-brand-mist/30">
          © {new Date().getFullYear()} Brandi Jo Newman · 7671 Enterprises &nbsp;·&nbsp;{" "}
          <Link to="/terms" className="hover:text-brand-gold transition-colors underline">Terms</Link> &nbsp;·&nbsp;{" "}
          <Link to="/privacy" className="hover:text-brand-gold transition-colors underline">Privacy</Link>
        </p>
      </div>
    </footer>
  </div>
);

export const LegalSection = ({ heading, children }) => (
  <section>
    <h2 className="font-serif text-2xl text-brand-mist mb-3">{heading}</h2>
    <div className="font-sans text-base text-brand-mist/75 leading-relaxed space-y-3">{children}</div>
  </section>
);
